var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "752pt",
    height: "752pt",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m401.57 512.39h-9.707v23.203h32.914v-152.02h-23.207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.85 299.52-16.336 16.336 24.625 24.863h-89.508v22.969h89.508l-24.625 24.629 16.336 16.336 52.57-52.566z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.78 168.81h-198.2v363.24l9.7109 3.5508 135.68 47.594v-367.97l-66.066-23.203h95.664v128.81h23.207z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b35729e657abdc5276cb44d801efeba4.svg";
export { ForwardRef as ReactComponent };